import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IConsolidation } from '../../models/IGlimpseReport';

@Component({
    selector: 'app-consolidation-chart',
    templateUrl: './consolidation-chart.component.html',
    styleUrls: ['./consolidation-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConsolidationChartComponent implements OnInit {
  result: { name: string; value: number }[] = [];
  colors: { domain: string[] } = { domain: [] };
  @Input() set consolidation(value: IConsolidation) {
    if (value.c.qty === 0 && value.nc.qty === 0 && value.nm.qty === 0) {
      this.result = [
        {
          name: 'No transactions',
          value: 100,
        },
      ];
      this.colors = { domain: ['#eeeeee'] };
    } else {
      this.result = [
        {
          name: 'Lost',
          value: this.pct(value.nm.pct),
        },
        {
          name: 'At-Risk',
          value: this.pct(value.nc.pct),
        },
        {
          name: 'Compliant',
          value: this.pct(value.c.pct),
        },
      ];
      this.colors = { domain: ['#f44235', '#ffc107', '#4caf50'] };
    }
  }

  @Input() width = 180;
  @Input() height = 180;

  constructor() {}

  ngOnInit() {}

  pct(num: number) {
    return Math.round(num * 100);
  }
}
